<div class="container">
  <div class="side-nav">
    <div class="neo-tabs vertical">
      @for (role of role_and_permission_list; track $index) {
      <div class="neo-tab" [class.active]="openedRole().id === role.id" (click)="setOpenedRole(role)">
        {{role.name}}
      </div>
      }
    </div>
  </div>
  <div class="content-wrapper">
    <div class="content">
      <div class="section">
        <div class="section-heading">
          Role Details
        </div>
        <div class="section-content" [formGroup]="roleAndPermissionForm">
          <div class="neo-input-wrapper">
            <label for="role_name" required>Role Name</label>
            <input pInputText type="text" name="role_name" id="role_name" formControlName="role_name"
              [readonly]="!userPrivileges.has('role.update')">
          </div>
          <div class="neo-input-wrapper">
            <label for="role_description" required>Description</label>
            <input pInputText type="text" name="role_description" id="role_description"
              formControlName="role_description" [readonly]="!userPrivileges.has('role.update')">
          </div>
        </div>
      </div>
      <div class="section">
        <div class="section-heading">
          Permission Details
        </div>
        <div class="section-content">
          <div class="section-item" style="display: flex; flex-direction: column; gap: 20px;">
            <div class="neo-tabs">
              @for (permission of permissionGroups; track $index) {
              <div class="neo-tab" [class.active]="permission.active" (click)="changeActivePermissionGroup(permission)">
                <i [class]="'tab-icon ' + permission.icon"></i>
                {{permission.label}}
              </div>
              }
            </div>

            <div class="active-sub-group-permissions">
              <div class="neo-tabs wrap">
                @for (subPermission of getActivePermissionsSubGroups(); track $index) {
                <div class="neo-tab" [class.active]="subPermission.active"
                  (click)="changeActiveSubPermissionGroup(subPermission)">
                  {{subPermission.label}}
                </div>
                }
              </div>
            </div>

            <div class="permissions-heading">
              Permissions
            </div>

            <div class="permissions-container">
              @for (permission of getActiveSubPermissionsValues(); track $index) {
              <div class="field-checkbox">
                <p-checkbox [binary]="true" [inputId]="permission.slug" [ngModel]="permission.isChecked"
                  [disabled]="!userPrivileges.has('role.update')"
                  (onChange)="togglePermissionNew(permission)">
                </p-checkbox>
                <label [for]="permission.slug" [style]="{paddingLeft: '10px'}" class="permission-title">{{
                  permission.name }}</label>
              </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content-footer" *ngIf="userPrivileges.has('role.update') || userPrivileges.has('role.delete')">
      <button class="delete-btn" pButton (click)="deleteRoleAndPermission(openedRole())" *ngIf="userPrivileges.has('role.delete')">
        Delete
      </button>
      <button class="create-btn" *ngIf="userPrivileges.has('role.update')" pButton (click)="updateRoleAndPermission()" [disabled]="saveBtnLoading"
        [loading]="saveBtnLoading">
        Save Changes
      </button>
    </div>
  </div>
</div>


<div *ngIf="isLoading" class="loadingOverlay center-loader">
  <p-progressSpinner [style]="{height: '30px', width: '30px'}" strokeWidth="7" animationDuration="0.5s">
  </p-progressSpinner>
</div>
<p-confirmpopup></p-confirmpopup>

@if (false) {
<div class="access-management-header">
  <h2 class="access-management-title">User Management</h2>
  <button 
    *ngIf="userPrivileges.has('role.create') && activeTab === 'roles'" 
    (click)="edit=false; openSideBar()" 
    class="create-new-button">Create New</button>
</div>

<div class="tab-buttons-container">
  <div class="tab-buttons">
    <button *ngIf="userPrivileges.has('user.view')"
      class="tab-button" 
      [ngClass]="{'active': activeTab === 'users'}"
      (click)="switchTab('users')">Users</button>
    <button *ngIf="userPrivileges.has('role.view')"
      class="tab-button" 
      [ngClass]="{'active': activeTab === 'roles'}"
      (click)="switchTab('roles')">Roles</button>
  </div>
</div>

<div *ngIf="activeTab === 'roles'">
  <div class="info-card">
    <div class="templates-container" *ngIf="role_and_permission_list.length > 0; else noRoleAndPermission">
      <div class="role-item" *ngFor="let role of role_and_permission_list">
        <div 
          class="role-header" 
          (click)="role.isOpen = !role.isOpen">
          <div class="role-info">
            <div class="role-name">{{role.name}}</div>
            <div class="role-id">ID: {{role.id}}</div>
          </div>
          <div class="role-actions">
            <span class="access-level">Custom Access</span>
            <i class="pi" [ngClass]="role.isOpen ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
          </div>
        </div>
        
        <div class="role-dropdown" *ngIf="role.isOpen">
          <div class="role-description">{{ role.description }}</div>
          <div class="dropdown-actions">
            <button 
              class="edit-role-btn" 
              (click)="edit=true; editOption(role); $event.stopPropagation()">
              Edit Permissions
            </button>
            <button 
              class="manage-permissions-btn" 
              (click)="deleteRoleAndPermission(role); $event.stopPropagation()">
              Delete Role
            </button>
          </div>
        </div>
      </div>
    </div>

    <ng-template #noRoleAndPermission>
      <div class="no-options text-style">No roles available.</div>
    </ng-template>
  </div>
</div>

<div *ngIf="activeTab === 'users'" class="user-list-wrapper">
  <app-user-list></app-user-list>
</div>
}

<p-dialog header="Add Role" (visibleChange)="addRoleAndPermissionSidebar = $event; setOpenedRole(openedRole(), true)" [visible]="!edit && addRoleAndPermissionSidebar" [modal]="true" [closable]="true" [draggable]="false"
    [resizable]="false" (onHide)="addRoleAndPermissionSidebar = false;roleAndPermissionForm.reset();">

    <div style="width: 55vw;">
      <div class="content-wrapper">
        <div class="content">
          <div class="section" [formGroup]="roleAndPermissionForm" >
            <div class="section-heading">
              Role Details
            </div>
            <div class="section-content">
              <div class="neo-input-wrapper">
                <label for="role_name" required>Role Name</label>
                <input id="role_name" type="text" class="inputtext" [attr.disabled]="edit ? true : undefined" id="inputtext"
                  pInputText formControlName="role_name" placeholder="Role Name"
                  [ngClass]="{'invalid': clicked && roleAndPermissionForm.controls['role_name'].errors}" rows>
                <app-handle-error class="err-msg" [clicked]="clicked" [control]="roleAndPermissionForm.get('role_name')"
                  name="Role Name"></app-handle-error>
              </div>
              <div class="neo-input-wrapper textarea-height">
                <label for="role_description" required>Role Description</label>
                <textarea id="role_description" formControlName="role_description" placeholder="Role Description"
                  pInputTextarea [autoResize]="true" [rows]="3" style="height: auto; width: 100%;"
                  [ngClass]="{'invalid': clicked && roleAndPermissionForm.controls['role_description'].errors}">
                    </textarea>
                <app-handle-error class="err-msg" [clicked]="clicked"
                  [control]="roleAndPermissionForm.get('role_description')" name="Description">
                </app-handle-error>
              </div>
            </div>
          </div>
          <div class="section">
            <div class="section-heading">
              Permission Details
            </div>
            <div class="section-content">
              <div class="section-content">
                <div class="section-item" style="display: flex; flex-direction: column; gap: 20px;">
                  <div class="neo-tabs">
                    @for (permission of permissionGroups; track $index) {
                    <div class="neo-tab" [class.active]="permission.active"
                      (click)="changeActivePermissionGroup(permission)">
                      <i [class]="'tab-icon ' + permission.icon"></i>
                      {{permission.label}}
                    </div>
                    }
                  </div>
    
                  <div class="active-sub-group-permissions">
                    <div class="neo-tabs wrap">
                      @for (subPermission of getActivePermissionsSubGroups(); track $index) {
                      <div class="neo-tab" [class.active]="subPermission.active"
                        (click)="changeActiveSubPermissionGroup(subPermission)">
                        {{subPermission.label}}
                      </div>
                      }
                    </div>
                  </div>
    
                  <div class="permissions-heading">
                    Permissions
                  </div>
    
                  <div class="permissions-container">
                    @for (permission of getActiveSubPermissionsValues(); track $index) {
                    <div class="field-checkbox">
                      <p-checkbox [binary]="true" [inputId]="permission.slug" [ngModel]="permission.isChecked"
                        (onChange)="togglePermissionNew(permission)">
                      </p-checkbox>
                      <label [for]="permission.slug" [style]="{paddingLeft: '10px'}" class="permission-title">{{
                        permission.name }}</label>
                    </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="dialog-action">
      <button pButton pRipple type="submit" [label]="edit ? 'Update' : 'Add New'"
        (click)="edit ? updateRoleAndPermission() : saveRoleAndPermission()" [disabled]="saveDisable || saveBtnLoading"
        [ngClass]="{'save_change_btn': !edit}" [loading]="saveBtnLoading" class="create-btn"></button>
    </div>

    @if (false) {
    <div class="addTemplate-header">
        <div class="addTemplate-heading"><em style="margin-right: 12.5px;" class="pi"></em>Create New Role</div>
        <div class="header-btn">
          <button pButton pRipple type="submit" label="Cancel" (click)='cancelRoleAndPermission()'
            class="p-button-outlined button-align save-btn"></button>
          <button pButton pRipple type="submit" [label]="edit ? 'Update' : 'Save Changes'" (click)="edit ? updateRoleAndPermission() : saveRoleAndPermission()" [disabled]="saveDisable"
            class="p-button-raised p-button-text button-align" [ngClass]="{'save_change_btn': !edit}" [loading]="saveBtnLoading"></button>
        </div>
    </div>
    <p-divider class="p-divider"></p-divider>
    <div class="templateForm" >
      <div [formGroup]="roleAndPermissionForm">
        <span class="p-float-label userForm-elements">
          <input type="text" class="inputtext" [attr.disabled]="edit ? true : undefined" id="inputtext" pInputText
            formControlName="role_name"
            [ngClass]="{'p-filled': roleAndPermissionForm.value.role_name,'invalid': clicked && roleAndPermissionForm.controls['role_name'].errors}">
          <label for="inputtext">Role Name <span [style]="{color: '#E24A47'}">*</span></label>
          <app-handle-error class="err-msg" [clicked]="clicked" [control]="roleAndPermissionForm.get('role_name')"
            name="Role Name"></app-handle-error>
        </span>
        <span class="role-desc-item">
          <label class="desc-label" for="role_description">
            Description <span style="color: #E24A47">*</span>
          </label>
          <textarea formControlName="role_description" placeholder="Type Role Description here" class="role-desc" rows="5"
          cols="30" pInputTextarea [autoResize]="true"
          [ngClass]="{'invalid': clicked && roleAndPermissionForm.controls['role_description'].errors}">
        </textarea>
          <app-handle-error class="err-msg" [clicked]="clicked" [control]="roleAndPermissionForm.get('role_description')" name="Description">
          </app-handle-error>
        </span>
      </div>
      <div>
        <div>
          <div class="permission_header"><span>Permissions</span></div>
          <ng-container *ngIf="_module_slug_list.length > 0; else noSlugList">
            <div *ngFor="let module of _module_slug_list">
              <div class="permission_container">
                <div class="permission_container_header" (click)="toggleExpand(module)">
                  <span class="permission_logo">
                    <img src="../../../assets/icons-svg/Institution.svg" alt="module-icon"> {{module.label}}
                  </span>
                  <span class="dropdown-icon">
                    <i [class]="module.isExpanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></i>
                  </span>
                </div>
                <div class="permission_container_content" *ngIf="module.isExpanded">
                  <div class="permission_select_all">
                    <p-checkbox 
                      name="category" 
                      [(ngModel)]="module.isSelectedAll" 
                      [binary]="true" 
                      [inputId]="module.slug"
                      (onChange)="updateSelectedCheckboxes(module, true)">
                    </p-checkbox>
                    <label [for]="module.slug" style="padding-left: 10px;">Select All</label>
                  </div>
                  <div *ngFor="let permission of module.permissions" class="field-checkbox">
                    <p-checkbox 
                      [binary]="true"
                      [inputId]="permission.slug"
                      [ngModel]="permission.isChecked"
                      (onChange)="togglePermission(module, permission)">
                    </p-checkbox>
                    <label [for]="permission.slug" style="padding-left: 10px;">{{ permission.name }}</label>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-template #noSlugList>
            <div class="no-options text-style">No permissions available.</div>
          </ng-template>
        </div>
      </div>
    </div>
    }
    <p-toast></p-toast>
</p-dialog>
